import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ServicesPoc() {
  const [tiers, setTiers] = useState([]);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/tiers");
        setTiers(res.data.tiers || []);
      } catch (e) {
        console.error(e);
        toast.error("Could not load tiers");
      }
    })();
  }, []);

  const handleBuy = async (tierId) => {
    setBusyId(tierId);
    try {
      const res = await api.post("/checkout/session", {
        tier_id: tierId,
        origin_url: window.location.origin,
      });
      if (res.data.url) {
        window.location.href = res.data.url;
      } else {
        toast.error("Stripe did not return a checkout URL");
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to create checkout session");
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="min-h-screen bg-stone-50 px-6 py-12" data-testid="services-poc-page">
      <div className="max-w-5xl mx-auto space-y-10">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-stone-500">
            Phase 0 spike · Stripe Checkout (test mode)
          </div>
          <h1 className="font-serif text-4xl text-stone-900 mt-2">Services</h1>
          <p className="text-stone-600 mt-3 max-w-2xl">
            Placeholder tier amounts. Click any tier to launch a real Stripe
            test-mode checkout. Use card{" "}
            <code className="bg-stone-100 px-1.5 py-0.5 rounded text-xs">
              4242 4242 4242 4242
            </code>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {tiers.map((t) => (
            <Card
              key={t.id}
              className="border-stone-200"
              data-testid={`tier-card-${t.id}`}
            >
              <CardHeader>
                <CardTitle className="text-stone-900 text-2xl font-serif">
                  {t.name}
                </CardTitle>
                <CardDescription>
                  <span className="text-3xl font-semibold text-stone-900">
                    ${t.amount.toFixed(2)}
                  </span>{" "}
                  <span className="uppercase text-xs tracking-wider text-stone-500">
                    {t.currency}
                  </span>
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Button
                  className="w-full"
                  disabled={busyId === t.id}
                  onClick={() => handleBuy(t.id)}
                  data-testid={`tier-buy-btn-${t.id}`}
                >
                  {busyId === t.id ? "Redirecting…" : "Purchase"}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
